export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};

export const ENVIRONMENTS = {
  PRODUCTION: 'Production',
  DEMO: 'Demo',
  TEST: 'Test',
  LOCAL: 'Local',
};

// Ember Dataset Manager: Snowflake table names
export const COMMODITY_CUSTOM_ATTRIBUTION_TABLE_ID = 2;
export const ITEM_ATTRIBUTION_TABLE_ID = 4;
export const CAMPAIGN_ATTRIBUTION_TABLE_ID = 32;
export const KEYWORD_ATTRIBUTION_TABLE_ID = 35;

// Regex
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX = /^[+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,9}$/;

// UI Animation and Timing Constants
export const ALERT_BADGE_PULSE_INTERVAL = 30; // seconds
export const ALERTS_REFRESH_INTERVAL = 30000; // milliseconds

// Process AI
export const PROCESS_AI_GROUP_OVERRIDE_KEY = 'lanternal.processAiGroup';
export const DEFAULT_PROCESS_AI_GROUP = 'Console Process AI';

export const getProcessAiGroupName = () => {
  if (typeof window !== 'undefined') {
    const override =
      (window.__LANTERNAL_CONFIG__ && window.__LANTERNAL_CONFIG__.processAiGroup) ||
      localStorage.getItem(PROCESS_AI_GROUP_OVERRIDE_KEY);
    if (override && typeof override === 'string') {
      return override;
    }
  }

  return DEFAULT_PROCESS_AI_GROUP;
};

export const PROCESS_AI_GROUP = getProcessAiGroupName();

// Emails
export const CONTRACTS_EMAIL = 'contracts@harvestgroup.com';

// Security Groups
export const HARVEST_EMPLOYEES_GROUP = 'Harvest Employees';
export const MONDAY_ADMINS_GROUP = 'Admins_monday.com';
export const MONDAY_SMES_GROUP = 'SMEs_monday.com';
export const CONSOLE_DEVELOPERS_GROUP = 'Console_RBAC_Developers';
export const CONSOLE_ADMINS_GROUP = 'Console_RBAC_Admins';
export const CONSOLE_PERMISSION_MANAGERS_GROUP = 'Console_RBAC_PermissionManagers';
export const CONSOLE_PERMISSIONS_REFRESH_GROUP = 'Console_RBAC_UserPermissions_RefreshSecurity';
export const CONSOLE_CLIENT_ATTRIBUTION_GROUP = 'Console_RBAC_ClientAttribution';
export const CONSOLE_FINANCE_GROUP = 'Console_RBAC_Finance';
export const CONSOLE_GROWTH_GROUP = 'Console_RBAC_Growth';
